import sponsoredOffers from './sponsoredOffers';

export default sponsoredOffers;
